module.exports = __webpack_public_path__ + "img/oak-leaf1.f4dcedd1.jpg";